import * as styles from "./MenuSeparator.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Menu as BaseMenu } from "@base-ui/react/menu";

import type { MenuSeparatorProps } from "./Menu.types";

export function MenuSeparator({
  className,
  ...props
}: MenuSeparatorProps): JSX.Element {
  return (
    <BaseMenu.Separator
      data-slot="menu-separator"
      className={clsx(styles.separator, className)}
      {...props}
    />
  );
}
